import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RecaptchaState } from './recaptcha.model';
import { ModuleTokens } from './recaptcha.constant';

export const slice = createFeatureSelector<RecaptchaState>(ModuleTokens.Name);

export const state = createSelector(slice, (s) => s.active);
